import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-ContentNearBy" */'@modals/partials/ContentNearBy'));
